const consumerFlow = [
  /*** Step 0 ***/
  ["Home"],

  /*** Step 1 ***/
  ["Addresses"],

  /*** Step 2 ***/
  ["TitolareEffettivo", "Gianos", "ScopoRapporto"],

  /*** Step 3 ***/
  ["MinorCardDocumentation", "MinorCardSign"],

  /*** Step 4 ***/
  ["ConfirmAccessCode", "MinorConfirmMobileToken"],

  /*** Step 5 ***/
  ["MinorWaitingTutorConfirm"],

  /*** Step 6 has beend merged with step 5  ***/
  //TODO: check this
  ["MinorRegistrationCompleted"],
  /*** Step 7 [user status: ?] ***/
  ["MinorRegistrationCompleted"],
  /*** Step 8 [user status: ?] ***/
  ["MinorRegistrationCompleted"],
  /*** Step 9 [user status: CONFIRMED] ***/
  ["MinorRegistrationCompleted"]
];

export default consumerFlow;
